import { render, staticRenderFns } from "./AdminTheme.vue?vue&type=template&id=371838a2&scoped=true"
import script from "./AdminTheme.vue?vue&type=script&lang=ts"
export * from "./AdminTheme.vue?vue&type=script&lang=ts"
import style0 from "./AdminTheme.vue?vue&type=style&index=0&id=371838a2&prod&lang=scss&scoped=true"
import style1 from "./AdminTheme.vue?vue&type=style&index=1&id=371838a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371838a2",
  null
  
)

export default component.exports